<app-button-outline
  [action]="downloadLogAction"
  [isHighlight]="false"
  [typeOfButton]="ButtonOutline[1]"
  [disabled]="!stateManagerProjectService.isViewerLoaded || !isManagerRole"
></app-button-outline>
